module.exports = __webpack_public_path__ + "assets/6b0b7d1928e43bbe42835c1d1d5ae6b8.json";